import { useState } from "react";
import useURLQuery from "$hooks/useURLQuery";
import { EDBIntegratedOrders } from "$types/EDBIntegratedOrders";
import { ProfileEDBStateTypes } from "../types/profileEDB.types";

export default function useProfileEDBState(): ProfileEDBStateTypes {
  const urlQuery = useURLQuery();

  const [, setVal] = useState(0);
  const [showCart, setShowCart] = useState(false);
  const [isDeleteEdb, setIsDeleteEdb] = useState(false);
  const [isCancelEdb, setIsCancelEdb] = useState(false);
  const [isDuplicateEdb, setIsDuplicateEdb] = useState(false);
  const [isModifyingEdb, setIsModifyingEdb] = useState(false);
  const [productToDeleteId, setProductToDeleteId] = useState("");
  const [isAddingMaterial, setIsAddingMaterial] = useState(false);
  const [notEditableProducts, setNotEditableProducts] = useState([]);
  const [openCartModalValidate, setOpenCartModalValidate] = useState(false);
  const [openModalCreateNewEdb, setOpenModalCreateNewEdb] = useState(false);
  const [openModalDeleteProduct, setOpenModalDeleteProduct] = useState(false);
  const [productToDeleteList, setProductToDeleteList] = useState<string[]>([]);
  const [displayDeliveryModality, setDisplayDeliveryModality] = useState(false);

  const [openModalDeleteMultipleProduct, setOpenModalDeleteMultipleProduct] =
    useState(false);

  const [productsQuantityMap, setProductsQuantityMap] = useState<
    Map<string, number>
  >(new Map());

  const [integratedOrders, setIntegratedOrders] =
    useState<EDBIntegratedOrders>(null);

  const [currentTab, setCurrentTab] = useState(
    parseInt(urlQuery.get("tabpane") || "0", 10)
  );

  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);

  return {
    setVal,
    showCart,
    setShowCart,
    isDeleteEdb,
    setIsDeleteEdb,
    isCancelEdb,
    setIsCancelEdb,
    isDuplicateEdb,
    setIsDuplicateEdb,
    isModifyingEdb,
    setIsModifyingEdb,
    productToDeleteId,
    setProductToDeleteId,
    isAddingMaterial,
    setIsAddingMaterial,
    notEditableProducts,
    setNotEditableProducts,
    openCartModalValidate,
    setOpenCartModalValidate,
    openModalCreateNewEdb,
    setOpenModalCreateNewEdb,
    openModalDeleteProduct,
    setOpenModalDeleteProduct,
    productToDeleteList,
    setProductToDeleteList,
    displayDeliveryModality,
    setDisplayDeliveryModality,
    openModalDeleteMultipleProduct,
    setOpenModalDeleteMultipleProduct,
    productsQuantityMap,
    setProductsQuantityMap,
    integratedOrders,
    setIntegratedOrders,
    currentTab,
    setCurrentTab,
    isApprovalModalOpen,
    setIsApprovalModalOpen,
  };
}
